// src/pages/dashboard/DashboardLayout.jsx
export default function DashboardLayout({ sidebar, header, children, footer }) {
  return (
    <div className="diamond-dashboard">
      {sidebar}

      <main className="diamond-main">
        {header}

        <div className="ultra-content">
          {children}
        </div>

        {footer}
      </main>
    </div>
  );
}